import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import type { Tool } from '../../types/tools';
import { ToolIcon } from './ToolIcon';
import { cn } from '../../src/lib/utils';
type ToolCardProps = {
  tool: Tool;
  variant?: 'default' | 'featured' | 'compact';
  badge?: string;
  onNavigate?: () => void;
};

/** Tool card linking to the tool page via a standard, crawlable link. */
export function ToolCard({
  tool,
  variant = 'default',
  badge,
  onNavigate
}: ToolCardProps) {
  const featured = variant === 'featured';
  const compact = variant === 'compact';
  return <Link to={`/tools/${tool.slug}`} onClick={onNavigate} className={cn('group flex h-full flex-col rounded-2xl border bg-panel transition-[border-color,box-shadow,transform] duration-200 hover:-translate-y-0.5 hover:border-[#D8D4EA] hover:shadow-[0_18px_40px_-28px_rgba(32,22,95,0.35)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lime focus-visible:ring-offset-2 focus-visible:ring-offset-ink motion-reduce:transition-none motion-reduce:hover:translate-y-0', featured ? 'border-[#E3DFF4] p-6 sm:p-7' : 'border-hairline', compact ? 'p-4' : !featured && 'p-5')} data-id="element-1468" data-mp="21bkm2s2uh3fv">
      <div className="flex items-start justify-between gap-3" data-id="element-1469" data-mp="3r5uat0cmyvl7">
        <ToolIcon name={tool.icon} size={featured ? 'lg' : compact ? 'sm' : 'md'} data-id="element-1470" data-mp="3w2awzp09yzvn" />
        {badge ? <span className="rounded-md border border-[#E3DFF4] bg-[#F5F3FC] px-2 py-0.5 text-[10px] font-semibold uppercase tracking-[0.08em] text-lime" data-id="element-1471" data-mp="noc7953wcaql">
            {badge}
          </span> : null}
      </div>
      <h3 className={cn('font-semibold tracking-[-0.015em] text-text-primary', featured ? 'mt-5 text-xl' : compact ? 'mt-3 text-[15px]' : 'mt-4 text-base')} data-id="element-1472" data-mp="dol98tg4ndlr">
        {tool.name}
      </h3>
      <p className={cn('mt-1.5 flex-1 leading-relaxed text-text-secondary', compact ? 'text-[13px]' : 'text-sm')} data-id="element-1473" data-mp="2yhonc5u76sho">
        {tool.cardDescription}
      </p>
      <span className={cn('inline-flex items-center gap-1.5 font-semibold text-lime', compact ? 'mt-3 text-[13px]' : 'mt-5 text-sm')} data-id="element-1474" data-mp="2fapa37vpbqz0">
        Explore Tool
        <ArrowRightIcon className="h-3.5 w-3.5 transition-transform duration-200 group-hover:translate-x-0.5 motion-reduce:transition-none" aria-hidden="true" data-id="element-1475" data-mp="25kxcs5w7wjqu" />
      </span>
    </Link>;
}